import React, {Fragment} from "react";
import {useDispatch} from "react-redux";
import CommonHeader from "../../components/Headers/CommonHeader";
import AddressModal from "../../components/Modal/AddressModal";
import SafeView from "../../components/safeView/SafeView";
import ProtectedContent from "../../components/protectedContent";
import PageURLContextProvider from "../../contexts/pageURLContext";
import {useDisclosure} from "../../hooks/useDisclosure";
import AddressTable from "./addressTable";
import {addressActions} from "./addressTable/addressTable.constants";
import {useFetchAddress} from "./addressTable/useAddressTableData";

const AddressComponent = () => {
  const dispatch = useDispatch();
  const {refetch} = useFetchAddress();
  const {isOpen: isModalOpen, onOpen: openModal, onClose: closeModal} = useDisclosure();

  const onSubmitHandler = (addressObj) => {
    const callback = () => {
      closeModal();
      refetch();
    };

    dispatch(addressActions.create(addressObj, callback));
  };

  return (
    <SafeView>
      <ProtectedContent perms={["view_organizationaddress"]} showFallback>
        <Fragment>
          {isModalOpen && (
            <AddressModal
              onCancel={closeModal}
              onSubmit={onSubmitHandler}
              open={isModalOpen}
            />
          )}
          <ProtectedContent perms={["add_organizationaddress"]}>
            <CommonHeader
              content={"Add Address"}
              handleAddClick={openModal}
              testID={"add_Address"}
            />
          </ProtectedContent>
          <AddressTable />
        </Fragment>
      </ProtectedContent>
    </SafeView>
  );
};

const AddressView = () => {
  return (
    <PageURLContextProvider>
      <AddressComponent />
    </PageURLContextProvider>
  );
};

export default AddressView;
